import { getLocalizedValue } from '@grandvisionhq/utils';

const mapShippingMethods = ({ asides , locale , logos , shippingMethodInfo , shippingMethodList  })=>{
    if (!shippingMethodList || !shippingMethodList.length) {
        return [];
    }
    const items = shippingMethodList.map((method)=>{
        const label = method.localizedDescription ? getLocalizedValue(method.localizedDescription, locale) : '';
        return {
            value: method.key,
            label,
            id: method.id,
            subtext: asides && asides[method.key],
            aside: shippingMethodInfo({
                price: method.price,
                logo: logos && logos[method.key],
                isFree: Boolean(method.isFree)
            })
        };
    });
    return items;
};

export { mapShippingMethods };
//# sourceMappingURL=shipping-methods.js.map
